globalThis.masterBackoffice = globalThis.masterBackoffice || {};

masterBackoffice.ImageLibrary = (function()
{
  function ImageLibrary(options) {
    this.$form = $('form#update-library');
    this.$actionBtns = $('a.library-action');
    this.$actionsDropdown = $('.library-actions-dropdown');
    this.$imageThumbnails = $('.library-image-thumbnail-wrapper');
    this.init();
  }

  ImageLibrary.prototype = {
    init: function() {
      var me = this;
      this.$imageThumbnails.each(function() {
        var $this = $(this);
        if($this.find('input[type="checkbox"]:checked').length === 1) {
          $this.find('label').addClass('selected');
          me._activateActionBtns();
        }
      });

      $('.library-image-thumbnail-wrapper input[type="checkbox"]').change(function(event) {
        var $this = $(this);
        if($this.prop('checked')) {
          $this.parents("label").addClass('selected');
        } else {
          $this.parents("label").removeClass('selected');
        }
      });

      $('.library-image-thumbnail-wrapper > label').click(function(event) {
        var $this = $(this);
        var $input = $this.find('input[type="checkbox"]');
        if(event.shiftKey) {
          $other_inputs = $('.library-image-thumbnail-wrapper input[type="checkbox"]').not($input);
          if($input.prop('checked')) {
            $other_inputs.prop('checked', true).change();
          } else {
            $other_inputs.prop('checked', false).change();
          }
        }
      });

      this.events();
    },
    initSearch: function() {
      return new ImageLibrary.Search();
    },
    events: function() {
      var me = this;

      this.$imageThumbnails.on('change', 'input[type="checkbox"]', function(e)
      {
        if(me.$imageThumbnails.find('input[type="checkbox"]:checked').length >= 1) {
          me._activateActionBtns();
        } else {
          me._activateActionBtns(true);
        }
      }).first().change();

      this.$actionBtns.on('click', function(e) {
        e.preventDefault();
        var $this      = $(this),
            $input     = me.$form.find('input[name=library_action]'),
            action     = $this.data('library-action'),
            method     = $this.data('method'),
            confirmTxt = $this.data('confirm-text');

        if(action) {
          $input.val(action);

          if(confirmTxt) {
            if(confirm(confirmTxt)) {
              me.$form.attr('method', method).submit();
            }
          } else {
            me.$form.attr('method', method).submit();
          }
        }
      });

      this.$imageThumbnails
        .on('mouseenter', function() {
          var $wrapper = $(this);
          var url = $wrapper.data('ai-search-status-url');

          if(!url) return;

          if(me.AISearchStatusTimeout) clearTimeout(me.AISearchStatusTimeout);
          if(me.AISearchStatusXhr) me.AISearchStatusXhr.abort();

          me.AISearchStatusTimeout = setTimeout(function() {
            me._fetchAISearchStatus($wrapper, url, function(data) {
              if(data.response) {
                me._updateAISearchStatusTooltip($wrapper.find('label'), data.label);
              }
            }, function(xhr) {
              if(xhr.statusText === 'abort') return;
            });
          }, 200);
        })
        .on('mouseleave', function() {
          if(me.AISearchStatusTimeout) clearTimeout(me.AISearchStatusTimeout);
          if(me.AISearchStatusXhr) me.AISearchStatusXhr.abort();
        });
    },
    _fetchAISearchStatus: function($wrapper, url, onSuccess, onFail) {
      this.AISearchStatusCache = this.AISearchStatusCache || {};

      var me = this;
      var imageId = $wrapper.data('image-id');
      var cached = me.AISearchStatusCache[imageId];

      if(cached) {
        onSuccess(cached);
        return;
      }

      me.AISearchStatusXhr = $.get(url, function(data) {
        if(data.response) {
          me.AISearchStatusCache[imageId] = data;
        }
        onSuccess(data);
      }).fail(onFail);
    },
    _updateAISearchStatusTooltip: function($label, statusLabel) {
      var dimensionsTitle = $label.data('dimensions-title');
      var title = dimensionsTitle ? [dimensionsTitle, statusLabel].join(' - ') : statusLabel;

      $label.attr('title', title).tooltip('fixTitle').tooltip('show');
    },
    _activateActionBtns : function(disable) {
      this.$actionsDropdown.prop('disabled', !!disable);
    }
  }

  ImageLibrary.Search = (function() {
    function Search() {
      if(($form = $('#search-apis-form')) && $form.length) {
        this.$form = $form;
        this.$createForm = $("#create-from-apis-form");
        this.$createBtn = $("button#create-images");
        this.$input = $form.find('input.search');
        this.$container = $('#images-container');
        this.$loadMore = $('#load-more');
        this.$selectedCounter = $('.selected-images .counter');
        this.page = 1;
        this.init();
      }
    }

    Search.prototype = {
      init: function() {
        this.events();
        this._template();
      },
      events: function() {
        var me = this;

        this.$form.on('submit', function() {
          me.keyword = $(this).val();
          me._clean();
          me.search();

          return false;
        });

        this.$container.on('click', '.item:not(.disabled)', function() {
          var $this = $(this);
          $this.toggleClass('checked');
          me._manageCreationInputs($this);
          if(length = me.$container.find('.item.checked').length) {
            me.$createBtn.prop('disabled', false);
          } else {
            me.$createBtn.prop('disabled', true);
          }

          me.$selectedCounter.text(length);
        });

        this.$loadMore.on('click', function() {
          me.search();
        });
      },
      search: function() {
        var me = this;

        masterBackoffice.MainLoader.loading();

        me._setFormInputValues();

        $.get(me.$form.attr('action'), me.$form.serialize(), function(data) {
          if(data.response) {
            if(data.results.length) {
              me.page++;
              me._displayResults(data.results);
              me.$loadMore.prop('disabled', false).show();
              me.$container.flexImages({ container: '.item' + (data.hide_existing_images ? ':not(.disabled)' : ''), rowHeight: 150 });
            } else {
              me.$loadMore.prop('disabled', true);
            }

            me._setStats(data.stats);
          }

          masterBackoffice.MainLoader.finish();
        }).fail(function() {
          alert('Une erreur s\'est produite...');
        });
      },
      _setFormInputValues: function() {
        this.$form.find('input[name=page]').val(this.page);
      },
      _displayResults: function(results) {
        var me = this;

        $.each(results, function(index, result) {
          var template = me.template.clone()
                                    .find('img').attr('src', result.preview_url)
                                    .end()
                                    .appendTo(me.$container)
                                    .attr('data-w', result.width).attr('data-h', result.height)
                                    .data('url', result.url)
                                    .data('origin', [result.origin, result.url].join(' | '))
                                    .data('licence', result.licence)
                                    .data('external_id', [result.origin, result.external_id].join('_'))
                                    .addClass(result.origin);
          if(result.disabled) {
            template.addClass('disabled')
                    .attr('title', 'Cette image a déjà été ajoutée');
          } else {
            template.attr('title', [result.width, result.height].join('x'));
          }

          template.tooltip();
        });
      },
      _manageCreationInputs: function($item) {
        var me = this;

        if($item.hasClass('checked')) {
          $.each(['url', 'origin', 'licence', 'external_id'], function(index, attribute) {
            if(value = $item.data(attribute)) {
              $('<input/>', {
                type: 'hidden',
                name: 'library_images_apis[images][][' + attribute + ']',
                value: value,
                "data-id": $item.index()
              }).appendTo(me.$createForm);
            } else {
              throw 'Data ' + attribute + ' is not set'
            }
          });
        } else {
          this.$createForm.find(`input[data-id="${$item.index()}"]`).remove();
        }
      },
      _setStats: function(stats) {
        $.each(stats, function(stat, value) {
          var $stat = $('.apis-results .' + stat);
          $stat.find('.counter').text(Number($stat.find('.counter').text()) + value.total)
                                .end()
                                .find('.response-time').text('(' + value.response_time + 's)');
        });
        $('.disabled .counter').text($('.item.disabled').length);
      },
      _clean: function() {
        this.$container.empty();
        this.$createForm.find('input[name*=images]').remove();
        this.page = 1;
        $('.counter').each(function() { $(this).text(0) });
        this.$selectedCounter.text(0);
      },
      _template: function() {
        this.template = $($('template#image-template').html().trim())
      }
    }

    return Search;
  })();

  return ImageLibrary;
})();
